import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { CloneConvertSizeChartResponseData, DataResponse } from "schema"
import { z } from "zod"

type CloneSizeChartPayload = {
  imageMetafieldKey?: string
  productId: string
  sizeChartMetafieldKey?: string
  variantId?: string
}

type Response = DataResponse<z.infer<typeof CloneConvertSizeChartResponseData>>

export function useShopifyCloneSizeChartMutation() {
  return useMutation({
    mutationFn: async (data: CloneSizeChartPayload) => {
      const response = await axios.get<Response>("/integrations/shopify/size-chart/clone-source", {
        params: data,
      })

      return response.data.data
    },
  })
}
